import { render, staticRenderFns } from "./CustomerFormDefaultData.vue?vue&type=template&id=2496be0a&"
import script from "./CustomerFormDefaultData.vue?vue&type=script&lang=js&"
export * from "./CustomerFormDefaultData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormDefaultData.vue?vue&type=style&index=0&id=2496be0a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports